import React from "react";
import { Box, Typography } from "@material-ui/core";
import theme from "../../../theme";

// SectionCard — wrapper chuẩn cho mỗi khối nội dung trong modal đề tài Cơ sở.
// Đồng bộ với StudentProject/utils/SectionCard.
export default function SectionCard({ icon, title, marginTop = 2, children }) {
  const renderTitle = () => {
    if (typeof title === "string") return <b>{title.toUpperCase()}</b>;
    return title;
  };
  return (
    <Box border="solid 1px #bcbcbc" borderRadius={4} marginTop={marginTop}>
      <Box
        display="flex"
        alignItems="center"
        bgcolor="#ececec"
        padding="8px 16px"
        borderBottom="solid 1px #bcbcbc"
        style={{ borderTopLeftRadius: 4, borderTopRightRadius: 4 }}
      >
        {icon &&
          React.cloneElement(icon, {
            style: {
              ...(icon.props?.style || {}),
              marginRight: 12,
              color: theme.palette.primary.main,
            },
          })}
        <Typography
          component="div"
          variant="h6"
          style={{ color: theme.palette.primary.main, flex: 1 }}
        >
          {renderTitle()}
        </Typography>
      </Box>
      <Box padding={2}>{children}</Box>
    </Box>
  );
}
